module.exports = __webpack_public_path__ + "static/media/rif.9fffd589.svg";